export default "__VITE_ASSET__4631446e__"